export const formatBytes = (value) => {
  const bytes = Number(value || 0);
  if (!bytes) return 'Size pending';
  const units = ['B', 'KB', 'MB', 'GB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / (1024 ** index)).toFixed(index ? 1 : 0)} ${units[index]}`;
};

export const testIdPart = (value) => String(value || 'unknown').replace(/[^a-zA-Z0-9_-]/g, '-');

export const kindTone = {
  video: 'border-blue-200 bg-blue-50 text-blue-800',
  novel: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  manuscript: 'border-violet-200 bg-violet-50 text-violet-800',
  image: 'border-pink-200 bg-pink-50 text-pink-800',
  other: 'border-amber-200 bg-amber-50 text-amber-800',
};

export const previewKind = (contentType = '') => {
  if (contentType.startsWith('image/')) return 'image';
  if (contentType.startsWith('video/')) return 'video';
  if (contentType.startsWith('audio/')) return 'audio';
  if (contentType === 'application/pdf') return 'pdf';
  return 'download';
};

export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => item?.msg).filter(Boolean);
    if (messages.length) return messages.join(' ');
  }
  if (detail && typeof detail === 'object') {
    return detail.message || detail.detail || fallback;
  }
  return fallback;
};